import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from 'app';
import './i18n';

createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
